import { createEvent, createStore, sample } from 'effector';
import { createGate } from 'effector-react';
import { getAppLaunchParamsFx } from '../lib/getAppLaunchParamsFx/getAppLaunchParamsFx';
import { getUserAccessTokenFx } from '../lib/getUserAccessTokenFx/getUserAccessTokenFx';
import { IAppLaunchParams } from './types';

export const UserGate = createGate();
export const GetVKAccessTokenGate = createGate();

const setIsStandAlone = createEvent<boolean>();
export const $isStandAlone = createStore<boolean | null>(null);
export const $userId = createStore<number>(-1);
export const $isUserUseMobileApp = createStore<boolean | null>(null);
const $appLaunchParams = createStore<IAppLaunchParams | null>(null);

export const $userAccessToken = createStore<string | null>(null);

sample({
  clock: setIsStandAlone,
  target: $isStandAlone
});

sample({
  clock: UserGate.open,
  source: $isStandAlone,
  filter: $isStandAlone => !$isStandAlone,
  target: [getAppLaunchParamsFx]
});

sample({
  clock: GetVKAccessTokenGate.open,
  fn: () => null,
  target: getUserAccessTokenFx
});

sample({
  clock: getAppLaunchParamsFx.doneData,
  target: $appLaunchParams
});

sample({
  clock: getUserAccessTokenFx.doneData,
  target: $userAccessToken
});

sample({
  clock: $appLaunchParams,
  filter: $appLaunchParams => !!$appLaunchParams?.vk_user_id,
  fn: $appLaunchParams => $appLaunchParams?.vk_user_id!,
  target: $userId
});

sample({
  clock: $appLaunchParams,
  fn: $appLaunchParams => $appLaunchParams?.vk_platform !== ('desktop_web'),
  target: $isUserUseMobileApp
});

window.addEventListener('message', event => {
  if (event.origin !== 'https://www.karusel-tv.ru') {
    return;
  }

  setIsStandAlone(true);
});
